import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { addContact } from "../../../store/actions"
import TitleDropdowns from "components/dropdowns/Other/titleDropdowns"
import OtherDropdowns from "components/dropdowns/Other/OtherDropdowns"
import SaveButton from "components/buttons/save"
import RsLink from "components/buttons/rsLink"
import { Row, Col, FormGroup, Label } from "reactstrap"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { API_URL } from 'helpers/app_url';
import axios from "axios"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import PhoneInputField from "components/dropdowns/PhoneInputField"
import SafeField from "helpers/SafeField";
class CreateContact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contactClassification: [],
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };

  componentDidMount() {

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;

    axios.get(`${API_URL}ContactClassification/allforagent?agentId=` + localStorage.getItem("userId"), {
      params: {
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ contactClassification: res.data });
      })
    //
  }


  handleSubmit = (values, actions) => {    
    const payload = {
      agentId: parseInt(localStorage.getItem("userId")),
      firstName: values.firstName,
      lastName: values.lastName,
      contactStatusId: values.contactStatusId? parseInt(values.contactStatusId) : 0,
      contactTypeId: values.contactTypeId ? parseInt(values.contactTypeId) : 0,
      contactSourceId: values.contactSourceId ? parseInt(values.contactSourceId) : 0,
      email: values.email,
      phone: values.phone,
      phoneExt: values.phoneExt,
      officePhone: values.officePhone,
      mobile: values.mobile,
      addressId: 0,
      fullAddress: values.fullAddress,
      addressLine1: values.addressLine1,
      addressLine2: values.addressLine2,
      nearestIntersection: values.nearestIntersection,
      city: values.city,
      province: values.province,
      postal: values.postal,
      country: values.country,
      longitude: values.longitude || 0,
      latitude: values.latitude || 0,
      organizationName: values.organizationName,
      jobTitle: values.jobTitle,
      lastContact: values.lastContact,
      isVendor: (values.isVendor) ? true : false,
      isClient: (values.isClient) ? true : false,
      isActive: (values.isActive) ? true : false,
      referedById: values.referedById ? parseInt(values.referedById) : 0,
      referedBy: values.referedBy,
      referralCode: values.referralCode,
      howOffenContact: values.howOffenContact,
      notes: values.notes,
      title: values.title,
      isInvestor: (values.isVendor) ? true : false,
      connectFrequency: values.connectFrequency,
      maritalStatus: values.maritalStatus ? parseInt(values.maritalStatus) : 0,
      secondaryPhone: values.secondaryPhone,
      officePhoneExt: values.officePhoneExt,
      contactClassificationId: values.contactClassificationId ? parseInt(values.contactClassificationId) : 0      
    }
    this.props.addContact(payload , (status) => {
        if (status=== true) {
          
          this.props.toggleAddNew();
        }
        actions.setSubmitting(false);
      })
  }
  render() {
    const { toggleAddNew } = this.props;

    return (
      <React.Fragment>

        <Formik
          enableReinitialize={true}
          initialValues={{
            agentId: parseInt(localStorage.getItem("userId")),
            firstName: '',
            lastName: '',
            contactStatusId: 0,
            contactTypeId: 0,
            contactSourceId: 0,
            email: '',
            phone: '',
            phoneExt: '',
            officePhone: '',
            mobile: '',
            addressId: 0,
            fullAddress: '',
            addressLine1: '',
            addressLine2: '',
            nearestIntersection: '',
            city: '',
            province: '',
            postal: '',
            country: '',
            longitude: '',
            latitude: '',
            organizationName: '',
            jobTitle: '',
            //lastContact: new Date(),
            isVendor: '',
            isClient: '',
            isActive: true,
            referedById: 0,
            referedBy: '',
            referralCode: '',
            howOffenContact: '',
            notes: '',
            //title: "",
            isInvestor: '',
            connectFrequency: '',
            maritalStatus: '',
            secondaryPhone: '',
            officePhoneExt: '',
            contactClassificationId: ''
            //lastContact: new Date()

          }}
          validationSchema={Yup.object().shape({
            // title: Yup.string().required(
            //   "This is required"
            // ),
            firstName: Yup.string().required(
              "Please Enter Your First Name"
            ),
            lastName: Yup.string().required(
              "Please Enter Your Last Name"
            ),
            email: Yup.string().email("Must be a valid Email")
              .max(255)
              .required("Email is required"),
            mobile: Yup.string().required("Email is required"),
            //phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
            //contactClassificationId: Yup.string().required("This is required"),
          })}

          onSubmit={this.handleSubmit}
        >
          {({ errors, touched, handleChange, values, setFieldValue }) => (
            <Form
              className="needs-validation"
            >


              <Row>
                {/* <Col md="3">
                  <FormGroup className="mb-3">
                    <Label htmlFor="lastContact">
                      {this.props.t("Last Contact ")}
                    </Label>
                    <Flatpickr
                      className={
                        "form-control" +
                        (errors.lastContact && touched.lastContact
                          ? " is-invalid"
                          : "")
                      }
                      placeholder=""

                      onChange={(value) => setFieldValue('lastContact', value[0])}
                      options={{
                        altInput: true,
                        altFormat: "F j, Y",
                        dateFormat: "Y-m-d"
                      }}
                    />


                  </FormGroup>
                </Col> */}
                {/* <Col md="3">
                <FormGroup className="mb-3">
                    <Label htmlFor="title">
                      {this.props.t("Title *")}
                    </Label>
                    <SafeField
                      name="title"
                      type="text"
                      onChange={handleChange}
                      className={
                        "form-control" +
                        (errors.title && touched.title
                          ? " is-invalid"
                          : "")
                      }
                      id="title"
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                 

                </Col> */}
                <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="firstName">
                      {this.props.t("First Name *")}
                    </Label>
                    <SafeField
                      name="firstName"
                      type="text"
                      onChange={handleChange}
                      className={
                        "form-control" +
                        (errors.firstName && touched.firstName
                          ? " is-invalid"
                          : "")
                      }
                      id="firstName"
                    />
                    <ErrorMessage
                      name="firstName"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

                <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="lastName">
                      {this.props.t("Last Name *")}
                    </Label>
                    <SafeField
                      name="lastName"
                      type="text"
                      onChange={handleChange}
                      className={
                        "form-control" +
                        (errors.lastName && touched.lastName
                          ? " is-invalid"
                          : "")
                      }
                      id="lastName"
                    />
                    <ErrorMessage
                      name="lastName"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <OtherDropdowns
                    name="maritalStatus"
                    label="Marital status"
                    fieldName="Lead:Marital Status"
                  />
                </Col>
                <Col md="3">
                  <FormGroup className="mb-3">
                    <Label htmlFor="contactClassificationId">
                      Classification *
                    </Label>
                    <SafeField as="select" name="contactClassificationId"
                      className={
                        "form-control" +
                        (errors.contactClassificationId && touched.contactClassificationId
                          ? " is-invalid"
                          : "")
                      }
                      onChange={handleChange}>
                      <option value="">Select</option>
                      {
                        this.state.contactClassification
                          .map(contactClassification =>
                            <option key={contactClassification.id} value={contactClassification.id}>{contactClassification.contactClassificationTitle}</option>
                          )
                      }
                    </SafeField>
                    <ErrorMessage
                      name="contactClassificationId"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

                <Col md="9">
                  <FormGroup className="mb-3">
                    <Label htmlFor="streetName">
                      {this.props.t("Address")}
                    </Label>


                    <PlacesAutocomplete
                      value={values.fullAddress}
                      onChange={(value) => setFieldValue('fullAddress', value)}
                      onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                    >
                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                          <input
                            {...getInputProps({
                              placeholder: 'Enter Address...',
                              className: 'form-control',

                            })}
                          />
                          <div className="">
                            {loading ? <div>Loading...</div> : null}

                            {suggestions.map((suggestion, i) => {
                              const className = suggestion.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                              const style = suggestion.active
                                ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                              return (
                                <div
                                  key={i}
                                  {...getSuggestionItemProps(suggestion, {
                                    style,
                                  })}
                                >
                                  {suggestion.description}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>

                  </FormGroup>
                </Col>
                 <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="connectFrequency" >
                      {this.props.t("Connect Frequency")}
                    </Label>
                    <SafeField as="select" name="connectFrequency"

                      className={
                        "form-control" +
                        (errors.connectFrequency && touched.connectFrequency
                          ? " is-invalid"
                          : "")
                      }>
                      <option value="">Select</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Quarterly">Quarterly</option>
                      <option value="Semi-annual">Semi-annual</option>
                      <option value="Annual">Annual</option>

                    </SafeField>
                    <ErrorMessage
                      name="connectFrequency"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                 <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="isVendor" >
                      {this.props.t("Is Vendor ")}
                    </Label>
                    <SafeField as="select" name="isVendor"

                      className={
                        "form-control" +
                        (errors.isVendor && touched.isVendor
                          ? " is-invalid"
                          : "")
                      }>
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>

                    </SafeField>
                    <ErrorMessage
                      name="isVendor"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="isInvestor" >
                      {this.props.t("Is Investor ")}
                    </Label>
                    <SafeField as="select" name="isInvestor"

                      className={
                        "form-control" +
                        (errors.isInvestor && touched.isInvestor
                          ? " is-invalid"
                          : "")
                      }>
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>

                    </SafeField>
                    <ErrorMessage
                      name="isInvestor"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="email">
                      {this.props.t("Email *")}
                    </Label>
                    <SafeField
                      name="email"
                      type="text"

                      onChange={handleChange}
                      className={
                        "form-control" +
                        (errors.email && touched.email
                          ? " is-invalid"
                          : "")
                      }
                      id="email"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

                <Col md="4">
                    <PhoneInputField
                      label="Mobile"
                      name="mobile"
                      value={values.mobile}
                      setFieldValue={setFieldValue}
                      error={errors.mobile}
                      touched={touched.mobile}
                      country="ca"
                      required={true}
                    />
                 
                </Col>
                <Col md="4">
                 <PhoneInputField
                      label="Secondary Phone"
                      name="phone"
                      value={values.phone}
                      setFieldValue={setFieldValue}
                      error={errors.phone}
                      touched={touched.phone}
                      country="ca"
                      required={false}
                    />
                  {/* <FormGroup className="mb-3">
                    <Label htmlFor="phone">
                      {this.props.t("Secondary Phone")}
                    </Label>
                    <SafeField
                      name="phone"
                      type="text"

                      onChange={handleChange}
                      className={
                        "form-control" +
                        (errors.phone && touched.phone
                          ? " is-invalid"
                          : "")
                      }
                      id="phone"
                    />
                    <ErrorMessage
                      name="phone"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup> */}
                </Col>
                {/* <Col md="2">
                  <FormGroup className="mb-3">
                    <Label htmlFor="phoneExt">
                      {this.props.t("Ext")}
                    </Label>
                    <SafeField
                      name="phoneExt"
                      type="text"
                      //value={values.phone}
                      onChange={handleChange}
                      className={
                        "form-control" +
                        (errors.phoneExt && touched.phoneExt
                          ? " is-invalid"
                          : "")
                      }
                      id="phoneExt"
                    />
                    <ErrorMessage
                      name="phoneExt"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col> */}
               
                {/* <Col md="3">
                  <FormGroup className="mb-3">
                    <Label htmlFor="isClient" >
                      {this.props.t("Is Client ")}
                    </Label>
                    <SafeField as="select" name="isClient"

                      className={
                        "form-control" +
                        (errors.isClient && touched.isClient
                          ? " is-invalid"
                          : "")
                      }>
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>

                    </SafeField>
                    <ErrorMessage
                      name="isClient"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col> */}
               




                <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="organizationName">
                      {this.props.t("Employer")}
                    </Label>
                    <SafeField
                      name="organizationName"
                      type="text"
                      className={
                        "form-control" +
                        (errors.organizationName && touched.organizationName
                          ? " is-invalid"
                          : "")
                      }
                      id="organizationName"
                    />
                    <ErrorMessage
                      name="organizationName"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup className="mb-3">
                    <Label htmlFor="jobTitle">
                      {this.props.t("Job title")}
                    </Label>
                    <SafeField
                      name="jobTitle"

                      type="text"

                      className="form-control"

                      id="jobTitle"
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                <PhoneInputField
                      label="Office phone"
                      name="officePhone"
                      value={values.officePhone}
                      setFieldValue={setFieldValue}
                      error={errors.officePhone}
                      touched={touched.officePhone}
                      country="ca"
                      required={false}
                    />
                  {/* <FormGroup className="mb-3">
                    <Label htmlFor="officePhone">
                      {this.props.t("Office phone")}
                    </Label>
                    <SafeField
                      name="officePhone"

                      type="text"

                      className="form-control"

                      id="officePhone"
                    />

                  </FormGroup> */}
                </Col>
                <Col md="2">
                  <FormGroup className="mb-3">
                    <Label htmlFor="officePhoneExt">
                      {this.props.t("Ext ")}
                    </Label>
                    <SafeField
                      name="officePhoneExt"

                      type="text"

                      className="form-control"

                      id="officePhoneExt"
                    />

                  </FormGroup>
                </Col>
              </Row>
              <div><SaveButton>{this.props.t("Save")}</SaveButton>{" "} <RsLink onClick={toggleAddNew}>Close</RsLink></div>




            </Form>
          )}
        </Formik>

      </React.Fragment>
    )
  }
}

CreateContact.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  error: PropTypes.any,
  addContact: PropTypes.func,
  toggleAddNew: PropTypes.object
}
const mapDispatchToProps = dispatch => ({
  addContact: (data, callback) => dispatch(addContact(data,callback)),
})
export default connect('', mapDispatchToProps)(withTranslation()(CreateContact))
